import React from 'react';

const ProjectDescription = (props) =>
{
    return(
        <div style={{
                fontSize: 20.9,
                color: '#2F3E4F',
                textAlign: "center",
                fontWeight: "bold"
            }}
        > { props.text }
        </div>
    )
};

export default ProjectDescription;